/**
 * Session snapshot of inventory overview numbers (same fields as statistics.inventory).
 * Used when the statistics slice is still at initial zeros after remount, and cleared on logout / mutations.
 */
let cached = null;

export function readInventoryOverviewStatsCache() {
  if (!cached) return null;
  return { ...cached };
}

export function writeInventoryOverviewStatsCache(stats) {
  if (!stats) return;
  cached = {
    totalItems: Number(stats.totalItems) || 0,
    totalStockValue: Number(stats.totalStockValue) || 0,
    totalStockCostValue: Number(stats.totalStockCostValue) || 0,
    lowStockItems: Number(stats.lowStockItems) || 0,
    totalStockQuantity: Number(stats.totalStockQuantity) || 0,
  };
}

export function invalidateInventoryOverviewStatsCache() {
  cached = null;
}
